(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anteqaat-category-circles"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    const cleanups=new WeakMap();
    const init=(root)=>{
      root.querySelectorAll('[data-aq-circles]').forEach(section=>{
        if(section.dataset.aqReady)return;
        section.dataset.aqReady='true';
        const viewport=section.querySelector('.aq-circles__viewport');
        const group=section.querySelector('.aq-circles__group:not([aria-hidden])');
        const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
        const controller=new AbortController();
        const listen=(target,event,handler,options={})=>target.addEventListener(event,handler,{...options,signal:controller.signal});
        let width=0,looping=false,visible=true,held=false,keyboardFocus=false;
        let resumeAt=0,lastTime=0,frame=0,drag=null,suppressClickUntil=0,autoPosition=null;
        const pause=()=>{resumeAt=performance.now()+2400;autoPosition=null;};
        const mod=(value,divisor)=>((value%divisor)+divisor)%divisor;
        const normalize=()=>{
          if(!looping||keyboardFocus)return;
          const position=-viewport.scrollLeft;
          if(position<width||position>=width*2)viewport.scrollLeft=-(width+mod(position,width));
        };
        const measure=()=>{
          const offset=width?mod(-viewport.scrollLeft,width):0;
          width=group.getBoundingClientRect().width;
          looping=!motion.matches&&width>viewport.clientWidth+1;
          section.classList.toggle('is-looping',looping);
          viewport.scrollLeft=-(offset+(looping?width:0));
          autoPosition=null;
        };
        section.classList.add('is-enhanced');
        measure();
        listen(viewport,'wheel',pause,{passive:true});
        listen(viewport,'scroll',()=>{
          if(performance.now()<resumeAt)pause();
          normalize();
        },{passive:true});
        listen(viewport,'pointerdown',event=>{
          if(!event.isPrimary||event.button!==0)return;
          held=true;pause();
          if(event.pointerType==='mouse')drag={id:event.pointerId,x:event.clientX,lastX:event.clientX,moved:false};
        });
        listen(viewport,'pointermove',event=>{
          if(!drag||event.pointerId!==drag.id)return;
          if(!drag.moved&&Math.abs(event.clientX-drag.x)<6)return;
          if(!drag.moved){drag.moved=true;viewport.setPointerCapture(event.pointerId);section.classList.add('is-dragging');}
          event.preventDefault();
          viewport.scrollLeft-=event.clientX-drag.lastX;
          drag.lastX=event.clientX;
          normalize();pause();
        });
        const release=()=>{
          if(drag?.moved)suppressClickUntil=performance.now()+350;
          if(drag&&viewport.hasPointerCapture(drag.id))viewport.releasePointerCapture(drag.id);
          drag=null;held=false;section.classList.remove('is-dragging');pause();
        };
        listen(window,'pointerup',release,{passive:true});
        listen(window,'pointercancel',release,{passive:true});
        listen(viewport,'lostpointercapture',()=>{if(drag)release();});
        listen(viewport,'dragstart',event=>event.preventDefault());
        listen(viewport,'click',event=>{if(performance.now()<suppressClickUntil){event.preventDefault();event.stopPropagation();}},{capture:true});
        listen(viewport,'focusin',event=>{keyboardFocus=event.target.matches(':focus-visible');pause();});
        listen(viewport,'focusout',()=>{keyboardFocus=false;pause();});
        listen(viewport,'keydown',event=>{
          pause();
          if(event.key==='ArrowLeft'||event.key==='ArrowRight'){
            event.preventDefault();
            const link=event.target.closest('a');
            const adjacent=link?.parentElement[event.key==='ArrowLeft'?'nextElementSibling':'previousElementSibling'];
            if(adjacent)adjacent.querySelector('a').focus();
          }
        });
        listen(motion,'change',measure);
        const resize=new ResizeObserver(measure);resize.observe(viewport);
        const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;});observer.observe(section);
        const tick=time=>{
          const elapsed=lastTime?Math.min(time-lastTime,40):0;lastTime=time;
          if(looping&&visible&&!document.hidden&&!held&&!keyboardFocus&&time>=resumeAt){
            autoPosition=width+mod((autoPosition??-viewport.scrollLeft)+elapsed*width/(group.children.length*4800),width);
            viewport.scrollLeft=-autoPosition;
          }
          frame=requestAnimationFrame(tick);
        };
        frame=requestAnimationFrame(tick);
        cleanups.set(section,()=>{controller.abort();resize.disconnect();observer.disconnect();cancelAnimationFrame(frame);});
      });
    };
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
    document.addEventListener('shopify:section:load',event=>init(event.target));
    document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-aq-circles]').forEach(section=>cleanups.get(section)?.()));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anteqaat-curated-group"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(root){root.querySelectorAll('.aq-curated--selection .aq-curated__grid').forEach(grid=>{if(grid.dataset.selectionReady)return;grid.dataset.selectionReady='true';let pauseUntil=0;const pause=()=>pauseUntil=Date.now()+6000;grid.addEventListener('pointerdown',pause);grid.addEventListener('touchstart',pause,{passive:true});grid.addEventListener('wheel',pause,{passive:true});setInterval(()=>{if(!grid.isConnected||document.hidden||Date.now()<pauseUntil||grid.matches(':hover')||grid.contains(document.activeElement)||matchMedia('(prefers-reduced-motion: reduce)').matches)return;const rect=grid.getBoundingClientRect();if(rect.bottom<0||rect.top>innerHeight)return;const step=grid.firstElementChild?.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).gap);if(!step)return;grid.scrollTo({left:grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-5?0:grid.scrollLeft+step,behavior:'smooth'});},3000);});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',event=>init(event.target));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anteqaat-home-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = scope => scope.querySelectorAll('[data-aq-film]').forEach(film => {
      const button = film.querySelector('button');
      if (!button || button.dataset.aqReady) return;
      button.dataset.aqReady = 'true';
      button.addEventListener('click', () => {
        const frame = film.querySelector('template')?.content.firstElementChild?.cloneNode(true);
        if (!frame) return;
        button.replaceWith(frame);
        frame.focus();
      }, { once: true });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once:true });
    else init(document);
    document.addEventListener('shopify:section:load', event => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anteqaat-home-reviews"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const cleanups=new WeakMap();
 const init=root=>root.querySelectorAll('.aq-home-reviews__grid').forEach(track=>{
  if(cleanups.has(track))return;
  const controller=new AbortController();
  const on=(target,event,handler,options={})=>target.addEventListener(event,handler,{...options,signal:controller.signal});
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  let visible=false,held=false,hovered=false,resumeAt=0;
  const pause=()=>{resumeAt=Date.now()+5000;};
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;},{threshold:0.5});
  observer.observe(track);
  on(track,'pointerenter',event=>{if(event.pointerType==='mouse')hovered=true;});
  on(track,'pointerleave',()=>{hovered=false;pause();});
  on(track,'pointerdown',()=>{held=true;pause();});
  on(window,'pointerup',()=>{if(held){held=false;pause();}});
  on(window,'pointercancel',()=>{held=false;pause();});
  on(track,'wheel',pause,{passive:true});
  on(track,'keydown',pause);
  on(track,'focusin',pause);
  on(track,'focusout',pause);
  const timer=setInterval(()=>{
   if(!track.isConnected||!visible||document.hidden||held||hovered||motion.matches||track.contains(document.activeElement)||Date.now()<resumeAt)return;
   const max=track.scrollWidth-track.clientWidth;
   if(max<=1)return;
   const step=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
   const position=Math.abs(track.scrollLeft);
   track.scrollTo({left:position>=max-2?0:-Math.min(position+step,max),behavior:'smooth'});
  },5000);
  cleanups.set(track,()=>{clearInterval(timer);observer.disconnect();controller.abort();cleanups.delete(track);});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('.aq-home-reviews__grid').forEach(track=>cleanups.get(track)?.()));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
 const placeCurrency = () => {
  const host = document.getElementById('AnteqaatFooterCurrency');
  const picker = document.querySelector('.bacurr-cur-block');
  if (host && picker && !host.contains(picker)) host.appendChild(picker);
 };
 placeCurrency();
 const observer = new MutationObserver(placeCurrency);
 observer.observe(document.body, {childList:true, subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if (!customElements.get('aq-collection-scroll')) {
  customElements.define('aq-collection-scroll', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-next]');
      this.status = this.querySelector('[role="status"]');
      this.grid = this.closest('#ProductGridContainer')?.querySelector('#product-grid');
      if (!this.link || !this.grid || !('IntersectionObserver' in window)) return;
      this.busy = false;
      this.failed = false;
      this.enhanced = true;
      this.clickHandler = (event) => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.failed = false;
        this.loadNext();
      };
      this.link.addEventListener('click', this.clickHandler);
      this.classList.add('is-enhanced');
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting) && !this.failed) this.loadNext();
      }, { rootMargin: '0px 0px 450px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.link?.removeEventListener('click', this.clickHandler);
    }

    async loadNext() {
      if (this.busy || !this.isConnected || !this.link.hasAttribute('href')) return;
      const url = new URL(this.link.href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      url.searchParams.set('section_id', this.dataset.section);
      this.busy = true;
      this.link.setAttribute('aria-disabled', 'true');
      this.status.textContent = this.dataset.loading;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 20000);
      try {
        const response = await fetch(url, { signal: this.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error('Collection request failed');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = html.querySelector('#product-grid');
        if (!nextGrid || nextGrid.dataset.id !== this.dataset.section) throw new Error('Invalid collection response');
        if (!this.isConnected || this.grid !== this.closest('#ProductGridContainer')?.querySelector('#product-grid')) return;
        const seen = new Set([...this.grid.children].map((item) => item.dataset.productId));
        const items = [...nextGrid.children].filter((item) => item.dataset.productId && !seen.has(item.dataset.productId));
        if (!items.length) throw new Error('Empty collection response');
        const fragment = document.createDocumentFragment();
        for (const item of items) {
          item.classList.add('scroll-trigger--cancel');
          item.querySelectorAll('img').forEach((img) => { img.loading = 'lazy'; });
          fragment.append(item);
        }
        this.grid.append(fragment);
        const nextLink = html.querySelector('aq-collection-scroll [data-next]');
        this.observer.disconnect();
        if (nextLink) {
          this.link.href = nextLink.getAttribute('href');
          this.status.textContent = this.dataset.loaded;
          this.observer.observe(this);
        } else {
          this.link.removeAttribute('href');
          this.link.hidden = true;
          this.status.textContent = this.dataset.complete;
        }
      } catch (error) {
        if (this.isConnected) {
          this.failed = true;
          this.status.textContent = this.dataset.error;
        }
      } finally {
        clearTimeout(timeout);
        this.busy = false;
        this.link.removeAttribute('aria-disabled');
      }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
